import React, { useEffect, useRef, useState } from "react";
import useNetworkStatus, { NETWORK_LEVELS, NETWORK_LEVEL_ORDER } from "../hooks/useNetworkStatus";

const SignalBars = ({ level, color }) => {
    let activeBars = 0;
    if (level === "excellent") activeBars = 4;
    else if (level === "good") activeBars = 3;
    else if (level === "slow") activeBars = 2;
    else if (level === "poor") activeBars = 1;

    return (
        <svg width="18" height="14" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle', marginTop: '-2px' }}>
            <rect x="1" y="9" width="2" height="3" rx="1" fill={activeBars >= 1 ? color : "#cbd5e1"} />
            <rect x="5" y="6" width="2" height="6" rx="1" fill={activeBars >= 2 ? color : "#cbd5e1"} />
            <rect x="9" y="3" width="2" height="9" rx="1" fill={activeBars >= 3 ? color : "#cbd5e1"} />
            <rect x="13" y="0" width="2" height="12" rx="1" fill={activeBars >= 4 ? color : "#cbd5e1"} />
        </svg>
    );
};

// Connectivity pill for the header. Click / tap opens the legend so the user can
const NetworkStatusIndicator = ({ compact = false, className = "" }) => {
    const { level, label, color, latency, refresh } = useNetworkStatus();
    const [isLegendOpen, setLegendOpen] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setLegendOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const latencyText = latency != null ? `${latency} ms` : "unreachable";

    return (
        <div
            className={`network-status-wrapper flex-shrink-0 ${className}`}
            ref={wrapperRef}
            title={`Network: ${label} (${latencyText})`}
        >
            <button
                type="button"
                className={`network-status-pill py-2 ${compact ? "network-status-pill-compact" : ""}`}
                onClick={() => setLegendOpen((open) => !open)}
                aria-label={`Network status: ${label}`}
            >
                <SignalBars level={level} color={color} />
                {!compact && <span className="network-status-label" style={{ color: color, fontWeight: 600, letterSpacing: "1px", fontSize: "11px", textTransform: "uppercase" }}>{label}</span>}
            </button>

            {isLegendOpen && (
                <div className="network-status-legend shadow">
                    <div className="network-status-legend-header">
                        <span>Network Connectivity</span>
                        <button
                            type="button"
                            className="network-status-refresh-btn"
                            onClick={() => refresh()}
                            title="Check again"
                        >
                            <i className="fa fa-refresh"></i>
                        </button>
                    </div>

                    <div className="network-status-current">
                        <span className="network-status-dot" style={{ backgroundColor: color }}></span>
                        <span className="network-status-current-label">{label}</span>
                        <span className="network-status-current-latency">{latencyText}</span>
                    </div>

                    <table className="network-status-legend-table">
                        <thead>
                            <tr>
                                <th>Indicator</th>
                                <th>Condition</th>
                            </tr>
                        </thead>
                        <tbody>
                            {NETWORK_LEVEL_ORDER.map((key) => (
                                <tr key={key} className={key === level ? "network-status-legend-active" : ""}>
                                    <td>
                                        <span
                                            className="network-status-dot"
                                            style={{ backgroundColor: NETWORK_LEVELS[key].color }}
                                        ></span>
                                        {NETWORK_LEVELS[key].label}
                                    </td>
                                    <td>{NETWORK_LEVELS[key].condition}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default NetworkStatusIndicator;
